export const getFullUrl = (url?: string) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  
  // Construct full Supabase Storage URL if it's a relative path
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  if (!supabaseUrl) return url;
  
  // Clean up any leading slash
  const cleanPath = url.startsWith('/') ? url.slice(1) : url;
  
  return `${supabaseUrl}/storage/v1/object/public/${cleanPath}`;
};
